@if (showHeader()) {
<header class="app-header">
  <a class="app-brand" routerLink="/" aria-label="MedOne Admin dashboard">
    <span class="app-brand__mark" aria-hidden="true">M</span>
    <span class="app-brand__text">MedOne Admin</span>
  </a>

  <span class="app-header__divider" aria-hidden="true"></span>

  <nav class="app-nav" aria-label="Primary">
    <a
      class="app-nav__link"
      routerLink="/requests"
      [class.app-nav__link--active]="requestsSectionActive()"
    >
      Requests
    </a>
    <a
      class="app-nav__link"
      routerLink="/requests/proxy-verifications"
      [class.app-nav__link--active]="proxyQueueSectionActive()"
    >
      Proxy Queue
    </a>
    <a
      class="app-nav__link"
      routerLink="/activity-logs"
      [class.app-nav__link--active]="auditLogSectionActive()"
    >
      Audit Log
    </a>
    <a class="app-nav__link" routerLink="/access-controls" routerLinkActive="app-nav__link--active">
      Access &amp; Controls
    </a>
  </nav>

  <span class="app-header__spacer"></span>

  @if (currentUser()) {
  <div class="user-menu">
    <button
      type="button"
      class="user-menu__trigger"
      [class.user-menu__trigger--open]="userMenuOpen()"
      [attr.aria-expanded]="userMenuOpen()"
      aria-haspopup="menu"
      (click)="toggleUserMenu($event)"
    >
      <span class="user-menu__avatar" aria-hidden="true">{{ userInitials() }}</span>
      <span class="user-menu__name">{{ userName() }}</span>
      <app-icon
        class="user-menu__caret"
        name="arrow_drop_down"
        size="sm"
        color="custom"
        customColor="currentColor"
        role="presentation"
      />
    </button>

    @if (userMenuOpen()) {
    <div class="user-menu__dropdown" role="menu">
      <div class="user-menu__section" role="presentation" (click)="$event.stopPropagation()">
        <span class="user-menu__section-label" id="appearance-label">Appearance</span>
        <div class="theme-toggle" role="radiogroup" aria-labelledby="appearance-label">
          @for (option of themeOptions; track option.mode) {
          <button
            type="button"
            class="theme-toggle__option"
            [class.theme-toggle__option--active]="themeMode() === option.mode"
            role="radio"
            [attr.aria-checked]="themeMode() === option.mode"
            (click)="setTheme(option.mode)"
          >
            {{ option.label }}
          </button>
          }
        </div>
      </div>

      <span class="user-menu__divider" role="separator"></span>

      <button type="button" class="user-menu__item" role="menuitem" (click)="signOut()">
        Sign out
      </button>
    </div>
    }
  </div>
  }
</header>
}

<main class="app-shell">
  <router-outlet></router-outlet>
</main>
